import React, { useContext, useEffect, useState } from "react"
import { NavLink } from "react-router-dom"
import { AuthContext } from "../../context/AuthContext"
import { db } from "../../firebase"
import {
    doc, 
    onSnapshot, 
    updateDoc, 
    collection,
    query,
    where,
    getDocs,
    getDoc,
    orderBy,
    or
} from "firebase/firestore"
import MessagesBoxSkeleton from "./MessagesBoxSkeleton"

const MessagesBox = ({setActiveChat, activeChat, thumbnailImage}) => {

    const { currentUser } = useContext(AuthContext)
    const [elementId, setElementId] = useState(null)
    const [chatListings, setChatListings] = useState(null)
    const [listings, setListings] = useState(null)
    const [chats, setChats] = useState(null)
    const [error, setError] = useState(false)

    const getListings = async(listingIds) => {
        const q = query(
                    collection(db, "listings"), where("id", "in", listingIds)
                )
        const listingsQuerySnapshot = await getDocs(q)
        const listingsQueryRes = {}
        listingsQuerySnapshot.forEach((doc) => {
            const docData = doc.data()
            listingsQueryRes[docData.id] = docData
        })
        return listingsQueryRes
    }

    const getChatListings = async() => {
        //TODO: consolidate buying and selling chats on the user data
        // const buyingListingIds = currentUser.activeChats.buying.map(chat => chat.listingId)
        // const buyingChatIds = currentUser.activeChats.buying.map(chat => chat.chatId)
        // const sellingListingIds = currentUser.activeChats.selling.map(chat => chat.listingId)
        // const sellingChatIds = currentUser.activeChats.selling.map(chat => chat.chatId)
        
        //TODO: make sure above to do is done and everything is still working as intended, then delete
        // const buyingListingIds = currentUser.activeChats.map(chat => chat.listingId)
        // const buyingChatIds = currentUser.activeChats.map(chat => chat.chatId)
        // const sellingListingIds = currentUser.activeChats.map(chat => chat.listingId)
        // const sellingChatIds = currentUser.activeChats.map(chat => chat.chatId)
        // const chatIds = [...new Set([...buyingChatIds, ...sellingChatIds])]
        // const listingIds = [...new Set([...buyingListingIds, ...sellingListingIds])]

        const listingIds = currentUser.activeChats.map(chat => chat.listingId)
        const chatIds = currentUser.activeChats.map(chat => chat.chatId)

        console.log(currentUser)
        console.log(chatIds)
        console.log(listingIds)

        if (listingIds.length > 0) {
            try {
                const chunks = []
                for (let i = 0; i < listingIds.length; i += 30) {
                    chunks.push(listingIds.slice(i, i+30))
                }
                // const q = query(
                //     collection(db, "listings"), where("id", "in", listingIds)
                // )
                // const listingsQuerySnapshot = await getDocs(q)
                // const listingsQueryRes = {}
                // listingsQuerySnapshot.forEach((doc) => {
                //     const docData = doc.data()
                //     listingsQueryRes[docData.id] = docData
                // })
                // setListings(listingsQueryRes)
                let listingsQueryRes = null
                // getListings(listingIds)
                await Promise.all(chunks.map(chunk => {
                    getListings(chunk)
                }))
                .then(res => {
                    console.log(res)
                    listingsQueryRes = res
                    setListings(res)
                })

                //TODO: "in" statement only supports up to 30 items and up to 100 with chunking, 
                // either add chunking logic to support more than 30 or look into other options to support more
                // const chatsQuery = query(
                //     collection(db, "chatrooms"), where(documentId(), "in", chatIds), orderBy("lastActive", "desc")
                // )
                // console.log("!!!!!1")
                // const chatsQuerySnapshot = await getDocs(chatsQuery)
                // console.log("!!!!!2")
                // const chatsArray = []
                // chatsQuerySnapshot.forEach(doc => chatsArray.push(doc.data()))
                // const chatListingsArray = chatsArray.map(chat => {
                //     chat.listing = listingsQueryRes[chat.listingId]
                //     if(chat.listing && chat.thumbnail !== chat.listing.image_urls[0]) {
                //         updateDoc(doc(db, "chatrooms", chat.chatId),
                //             {
                //                 thumbnail: chat.listing.image_urls[0]
                //             }
                //         )
                //         chat.thumbnail = chat.listing.image_urls[0]
                //     }
                //     return chat
                // })
                // setChatListings(chatListingsArray)
                // console.log("chat listings", listingsQueryRes)
                // console.log("chats ****", chatListingsArray)
            } catch(err) {
                console.error(err)
                setError(true)
            }
        } else {
            setChatListings([])
        }
    }

    useEffect(() => {
        getChatListings()
    }, [])

    const handleSetElement = async(e, chatId) => {
        console.log(elementId)
        console.log(e.target.getAttribute("chatid"))
        if (elementId !== null && e.target.getAttribute("chatid") !== elementId) {
            const element = document.getElementById(elementId)
            element.classList.remove("active")   
        } 
        setElementId(e.target.getAttribute("chatid"))
        await updateDoc(doc(db, "chatrooms", chatId),{
            unread: false
        })
    }

    //update active chat bubble and unread icons
    useEffect(() => {
        console.log(chatListings)
        if (elementId !== null) {
            const activeElements = document.querySelectorAll(".active")
            if (activeElements.length > 0) {
                activeElements.forEach(el => el.classList.remove("active"))
            }

            const element = document.getElementById(elementId)
            element.classList.add("active")
            element.classList.remove("unread")
        }
        
        if (chats && chats.length > 0) {
            const activeElements = document.querySelectorAll("button.unread")
            if (activeElements.length > 0) {
                activeElements.forEach(el => el.classList.remove("unread"))
            }

            chats.forEach((chat) => {
                if (chat.unread === true && chat.lastSender !== currentUser.uid) {
                    if (chat.chatId !== activeChat) {
                        const element = document.getElementById(chat.chatId)
                        element && element.classList.add("unread")
                    } else if (chat.chatId === activeChat) {
                        updateDoc(doc(db, "chatrooms", chat.chatId),{
                            unread: false
                        })
                    }
                }
            })
        }
    },[elementId, chatListings])

    //listen to updates on chatrooms
    useEffect(() => {
        const q = query(
            collection(db, "chatrooms"), 
            or(
                where("to.uid", "==", currentUser.uid),
                where("from.uid", "==", currentUser.uid)
            ),
            orderBy("lastActive", "desc")
        )

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const chatsRes = []
            querySnapshot.forEach((doc) => {
                chatsRes.push(doc.data())
            })

            console.log("snapshot", chatsRes)
            //Check is there is a new chat in the snapshot
            // if (chats) {
            //     const difference = chatsRes.filter(el1 => !chats.some(el2 => el1.chatId === el2.chatId))
            //     console.log(difference)
            //     if (!!difference.length && difference[0].lastActive.second > chats[0].lastActive.second) {
            //         getListings([difference.listingId])
            //         .then(res => {
            //             debugger
            //             setListings([...res, ...listings])
            //         })
            //     }   
            // }
            
            setChats(chatsRes)
        })
        return () => unsubscribe()
    }, [])

    //update order of chatrooms and add new chat if there is one
    useEffect(() => {
        console.log("listings", listings)
        console.log("chats", chats)

        if (listings && chats) {
            let newListingId = null

            const chatListingsArray = chats.map(chat => {
                if (listings[chat.listingId]) {
                    chat.listing = listings[chat.listingId]
                } 
                
                else {
                    newListingId = chat.listingId
                }
                return chat
            })

            if (newListingId) {
                getDoc(doc(db, "listings", newListingId))
                .then((res) => {
                    console.log("getting new listing data")
                    const listing = res.data()
                    if (listing) {
                        console.log(listing)
                        const index = chatListingsArray.findIndex(chat => chat.listingId === listing.id)
                        chatListingsArray[index].listing = listing
                        console.log(chatListingsArray)
                        setChatListings(chatListingsArray)
                        return
                    }
                })
            } 
            setChatListings(chatListingsArray)
        }
    }, [chats, listings])

    if (error) return <div style={{'margin-left': '16px'}}>Could not get messages</div>
    if (chatListings && chatListings.length === 0) return <div style={{'margin-left': '16px'}}>No messages found</div>
    if (chatListings === null) return <MessagesBoxSkeleton/>

    return (
        <div className="messages-box-container">
            {chatListings && chatListings.length > 0 ?
            <div className="messages-box list-group">
                <ul className="messages-list">
                    {chatListings.map((chat, i) => (
                        <button
                            key={`messages-list-${i}`}
                            id={chat.chatId}
                            chatid={chat.chatId}
                            className="list-group-item list-group-item-action"
                            onClick={
                                (e) => {
                                    setActiveChat(chat.chatId)
                                    handleSetElement(e, chat.chatId)
                                }
                            }
                            // to={{pathname: `/chat/${chat.chatId}`,}}
                        >
                            {/* <img className="chat-thumbnail" src={chat.listing ? chat.listing.image_urls[0] : null} chatid={chat.chatId}></img> */}
                            <img className="chat-thumbnail" src={chat.thumbnail} chatid={chat.chatId}></img>
                            <div className="message-box-text" chatid={chat.chatId}>
                                <div className="message-box-buying-selling-type" chatid={chat.chatId}>
                                    {currentUser.uid === chat.to.uid ? `Selling to` : `Buying from`}
                                    {/* {currentUser.uid === chat.listing.user.userId ? `Selling to` : `Buying from`} */}
                                </div>
                                <div className="message-box-chat-title" chatid={chat.chatId}>
                                    {currentUser.uid === chat.to.uid ? chat.from.firstName : chat.to.firstName} - {chat.listing ? chat.listing.title : chat.listingTitle}
                                    {/* {currentUser.uid === chat.listing.user.userId ? chat.from.firstName : chat.to.firstName} - {chat.listing ? chat.listing.title : null} */}
                                </div>
                            </div>
                            <div className="chat-notification-container"/>
                        </button>
                    ))}
                </ul>
            </div> :
            <div></div>}

        </div>
    )
}

export default MessagesBox